import React from "react";
import { Mail, MessageSquare } from "lucide-react";
import { useMailShake } from "./useMailShake";

// floating "new replies" nudge, visible on every screen; shakes when mail or SMS arrives
export function MailChip({ n, sms, unmatched, onClick }) {
  const shake = useMailShake("any");
  return (
    <button onClick={onClick} data-testid="mail-alert-chip"
      className={`fixed bottom-4 right-20 z-[55] inline-flex items-center gap-1.5 rounded-full bg-red-600 hover:bg-red-700 text-white shadow-xl px-4 py-2 text-[13px] font-black ${shake ? "mail-shake" : ""}`}>
      {n > 0 && <><Mail className="h-4 w-4" />{n} new {n === 1 ? "email" : "emails"}{unmatched ? ` (${unmatched} unmatched)` : ""}</>}
      {n > 0 && sms > 0 && <span className="opacity-60">·</span>}
      {sms > 0 && <><MessageSquare className="h-4 w-4" />{sms} new SMS</>}
    </button>
  );
}
